module.exports = "<div class=\"google-autocomplete\">\n\t<v-select \n\t\t@search=\"search\"\n\t\t@search:blur=\"resetResults\"\n\t\t:noDrop=\"results.length < 1\"\n\t\t:options=\"results\" \n\t\t:placeholder=\"placeholder\"\n\t\tv-model=\"selected\">\n\t</v-select>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/google-autocomplete/google-autocomplete.vhtml
// module id = 273
// module chunks = 0